export const formatPhoneNumber = (value: string): string => {
  // First, strip all non-digits
  const numbers = value.replace(/\D/g, '')

  // Limit to 10 digits if longer
  const trimmed = numbers.slice(0, 10)

  // Then format the numbers
  const match = trimmed.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/)
  if (!match) return ''

  const [, first, second, third] = match

  if (!second) return first
  if (!third) return `(${first}) ${second}`
  return `(${first}) ${second}-${third}`
}

/** Trim the phone number of type +12234567890 to 2234567890 */
export const trimPhoneNumber = (value: string): string => {
  return value.replace('+1', '').slice(-10)
}

export const formatPhoneNumberTextInput = (value: string, previousValue: string) => {
  if (value.length < previousValue.length) {
    if (/[-()]$/.test(previousValue)) {
      return previousValue.slice(0, -2)
    }
    return value
  }
  let cleaned = value.replace(/\D/g, '')
  // If the first number is 1, toss it out (common for US country code)
  if (cleaned[0] === '1') {
    cleaned = cleaned.slice(1)
  }
  const truncated = cleaned.slice(0, 10)

  // Format as (XXX)-XXX-XXXX
  if (truncated.length >= 6) {
    return `(${truncated.slice(0, 3)})-${truncated.slice(3, 6)}-${truncated.slice(6)}`
  } else if (truncated.length >= 3) {
    return `(${truncated.slice(0, 3)})-${truncated.slice(3)}`
  } else if (truncated.length > 0) {
    return `(${truncated}`
  }

  return truncated
}
